/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import '../Verfication/Verfication.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Logo from '../../assets/svg/logo.svg'

import loadingPic from '../../assets/svg/Loading.svg'

import { post } from '../../services/https'
import { useNavigate } from 'react-router-dom'

export default function index() {
  const [code, setCode] = useState()
  const [alertCode, setAlertCode] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const sendCodeHandler = (e) => {
    e.preventDefault()
    if (code !== undefined && code.length === 4) {
      setAlertCode(false)
      setLoading(true)
      post('/api/front/validatesms', {
          phoneNumber: localStorage.getItem('phoneNumber'),
          code: code
        }, {
        'Content-Type': 'application/json'
        }).then(response => {
          if (response.data.messageFa === "کد معتبر است") {
            navigate('/forget')
            localStorage.setItem('code', code)
          }
        }).catch(error => {
          if (error.response.data.messageFa === "کد معتبر نیست") {
            notify('error', "کد معتبر نیست")
            setLoading(false)
          } else {
            notify('error', 'دریافت اطلاعات با خطا مواجه شد')
          }
        })
    } else {
      setAlertCode(true)
    }
  }

  return (
    <div id='login'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <img src={Logo} alt='Logo' />
        <span className='title'>کانولی</span>
        <span className='subtitle'>خوش آمدید</span>
        <form action=''>
          <div className='input'>
            <label htmlFor=''>کد اعتبار سنجی :</label>
            <input type='text' onChange={(e) => setCode(e.target.value)} name='' id='' placeholder='کد اعتبار سنجی' />
            <small style={alertCode ? {} : { display: 'none' }}>کد صحیح نیست</small>
          </div>
          <div className='button'>
            <span>
            </span>
            <span>
              <button onClick={sendCodeHandler} style={{ whiteSpace: 'nowrap' }}>
                <span style={loading ? {display: 'none'} : {}}>ثبت</span>
                <img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' />
              </button>
            </span>
          </div>
        </form>
      </div>
      <Footer page={''} />
    </div>
  )
}
